import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { FinSobSidePanelSettingGroup } from 'partner360/models/finSobSidePanel/FinSobSidePanelSettingGroup'
import { FinSobSidePanelSettingStatus } from 'partner360/models/finSobSidePanel/FinSobSidePanelSettingStatus'
import { IFinSobSidePanelSetting } from 'partner360/models/finSobSidePanel/IFinSobSidePanelSetting'

export const defaultFinSobItem: IFinSobSidePanelSetting = {
  EntryId: 0,
  FYear: 0,
  IsApplicable: 1,
  IsApplicableDisabled: 0,
  IsBlocked: 0,
  IsMainHierarchy: 1,
  IsTotalCategory: 0,
  ProgramType: ProgramTypes.CorePrint,
  Status: FinSobSidePanelSettingStatus.Completed,
  SubTitle: '',
  Title: '',
  TitleOrder: 0,
  GroupMark: FinSobSidePanelSettingGroup.Planning,
}
